import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const IconButton = memo(
  ({ activeOpacity = 0.6, transparent, style, disabled, ...rest }) => {
    const { styles } = useStyle();
    return (
      <TouchableOpacity
        style={[
          styles.container,
          transparent && styles.transparenContainer,
          disabled && styles.disabledContainer,
          style,
        ]}
        {...{ activeOpacity, disabled }}
        {...rest}
      />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    width: size.iconButtonDefaultSize,
    height: size.iconButtonDefaultSize,
    backgroundColor: colors.gray7,
    padding: 8,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  transparenContainer: {
    backgroundColor: colors.transparent,
    padding: 0,
  },
  disabledContainer: {
    opacity: 0.3,
  },
}));
